import { styled } from '@mui/material/styles';
import { Tabs } from "@mui/material"
const AntTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
      backgroundColor: 'var(--accent-color)',
    },
  });
export default AntTabs  